import { Component, EventEmitter, Inject, OnInit, OnDestroy, Output } from '@angular/core';

import { RelatedCardFacade } from '@ridango/components';
import { AppStartupService, BaseComponent, RelatedCard } from '@ridango/core';

import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-related-cards-list',
    templateUrl: './related-cards-list.component.html',
    styleUrls: ['./related-cards-list.component.scss']
})
export class RelatedCardsListComponent extends BaseComponent implements OnInit, OnDestroy {
    relatedCardsLoaded$: Observable<boolean> = this.relatedCardFacade.loaded$;
    typeTravelcardCards$: Observable<RelatedCard[]> = this.relatedCardFacade.typeTravelcardCards$;
    selectedRelatedCard$: Observable<RelatedCard> = this.relatedCardFacade.selectedCard$;

    @Output() onCardSelected: EventEmitter<RelatedCard> = new EventEmitter<RelatedCard>();

    constructor(
        @Inject('ENV') public env: any,
        private relatedCardFacade: RelatedCardFacade,
        public appStartupService: AppStartupService
    ) {
        super();
    }

    ngOnInit() {
        this.selectedRelatedCard$.pipe(takeUntil(this.componentDestroyed$)).subscribe((card: RelatedCard) => {
            if (card) {
                this.onCardSelected.emit(card);
            }
        });
    }

    relatedCardSelected(card: RelatedCard) {
        this.relatedCardFacade.setSelectedRelatedCard(card);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
